__turbopack_context__.v({
  "active": "m5W00q_active",
  "brutaleApp": "m5W00q_brutaleApp",
  "container": "m5W00q_container",
  "groupWrapper": "m5W00q_groupWrapper",
  "selectedButton": "m5W00q_selectedButton",
  "subGroupWrapper": "m5W00q_subGroupWrapper",
  "wrapper": "m5W00q_wrapper",
});
